import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Typography, Checkbox, Spin, Button, Tooltip } from 'antd';
import moment from 'moment';

const { Text } = Typography;

const DSRSectionBreadcrumb = ({
  selectedDate,
  shift,
  sectionTitle,
  skipped,
  onSkipChange,
  isSubmitted = false,
  disabled = false,
  isUpdatingDsrLogSections = false,
  isShiftSkipped = false,
}) => {
  // Local state that syncs with parent but tracks user interaction
  const [localSkipped, setLocalSkipped] = useState(skipped);
  const hasUserInteracted = useRef(false);
  const lastParentValue = useRef(skipped);
  const currentSectionKey = useRef(`${sectionTitle}-${shift}`);

  // Sync with parent component's skip status
  useEffect(() => {
    // Only update if parent value changed and user hasn't interacted
    if (lastParentValue.current !== skipped) {
      lastParentValue.current = skipped;
      // If user hasn't interacted, sync with parent
      if (!hasUserInteracted.current) {
        setLocalSkipped(skipped);
      }
    }
  }, [skipped, sectionTitle]);

  // Reset user interaction only when section or shift actually changes
  useEffect(() => {
    const newSectionKey = `${sectionTitle}-${shift}`;
    if (currentSectionKey.current !== newSectionKey) {
      currentSectionKey.current = newSectionKey;
      hasUserInteracted.current = false;
      setLocalSkipped(skipped);
      lastParentValue.current = skipped;
    }
  }, [sectionTitle, shift, skipped]);

  // Handle local checkbox change - this is the only way localSkipped can change
  const handleSkipChange = (e) => {
    const newValue = e.target.checked;
    setLocalSkipped(newValue);
    hasUserInteracted.current = true;
    onSkipChange(e);
  };

  // Format the selected date or use today's date as fallback
  const displayDate = selectedDate
    ? moment(selectedDate).format('DD-MMM-YYYY')
    : moment().format('DD-MMM-YYYY');

  return (
    <div
      style={{
        padding: '2px 5px',
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        height: '32px',
        minWidth: 'fit-content',
      }}
    >
      <Text
        type="secondary"
        style={{
          fontSize: '14px',
          color: '#fff',
          fontWeight: '500',
        }}
      >
        Date: {displayDate}
      </Text>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {isUpdatingDsrLogSections && <Spin size="small" style={{ marginRight: 4 }} />}

        {isShiftSkipped ? (
          <div
            style={{
              color: '#faad14',
              fontSize: '14px',
              fontWeight: '500',
              backgroundColor: 'rgba(250, 173, 20, 0.1)',
              padding: '4px 10px',
              borderRadius: '25px',
              border: '1px solid #faad14',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {shift.charAt(0).toUpperCase() + shift.slice(1)} Shift Skipped
          </div>
        ) : (
          <Checkbox
            checked={localSkipped}
            onChange={handleSkipChange}
            className="red-checkbox"
            style={{
              // color: '#ff4d4f',
              '--antd-wave-shadow-color': '#ff4d4f',
              height: '24px',
              marginTop: '4px',
              display: 'flex',
              // alignItems: 'center'
            }}
            disabled={disabled || isUpdatingDsrLogSections}
          >
            <span
              style={{
                // color: '#ff4d4f',
                fontSize: '14px',
                fontWeight: '500',
              }}
            >
              Skip {sectionTitle}
            </span>
          </Checkbox>
        )}
      </div>
    </div>
  );
};

export default DSRSectionBreadcrumb;
